import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import LoadingSpinner from '../LoadingSpinner'
import { get_orders} from '../../store/reducers/orderReducer'

import { FaEye } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa'
import { socket } from '../../utils/utils'

const Orders = () => {
  // const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'
  const { userInfo } = useSelector((state) => state.auth)
  const { myOrders } = useSelector((state) => state.order)
  const [loading, setLoading] = useState(true)
  const [state, setState] = useState('all')
  const [sortedData, setSortedData] = useState([])
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' })

  console.log(myOrders);

  useEffect(() => {
    dispatch(get_orders({ status: state, customerId: userInfo?.id }))
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }, [state])

  useEffect(() => {
    socket.on('orderStatusUpdate', (data) => {
      dispatch(get_orders({ status: state, customerId: userInfo?.id }))
    })
  }, [])

  useEffect(() => {
    setSortedData(myOrders)
  }, [myOrders])

  // const redirect = (ord) => {
  //   let items = 0
  //   for (let i = 0; i < ord.length; i++) {
  //     items = ord.products[i].quantity + items
  //   }
  //   navigate('/payment', {
  //     state: {
  //       price: ord.price,
  //       items,
  //       orderId: ord._id,
  //     },
  //   })
  // }

  // const deleteOrders = () => {
  //   dispatch(delete_orders())
  // }

  const handleSort = (key) => {
    let direction = 'ascending'
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending'
    }
    setSortConfig({ key, direction })

    const sorted = [...sortedData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'ascending' ? -1 : 1
      }
      if (a[key] > b[key]) {
        return direction === 'ascending' ? 1 : -1
      }
      return 0
    })
    setSortedData(sorted)
  }

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <FaSort />
    }
    return sortConfig.direction === 'ascending' ? <FaSortUp /> : <FaSortDown />
  }

  return (
    <div>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="bg-white p-2 rounded-md">
          <div className="flex justify-between items-center">
            <h2 className="text-md font-semibold text-slate-600">
              {t('orderS.orders')}
            </h2>
            <select
              className="outline-none px-3 py-1 border rounded-md text-slate-600"
              value={state}
              onChange={(e) => setState(e.target.value)}
            >
              <option value="all">--{t('orderS.all_orders')}--</option>
              <option value="pending">{t('orderS.pending')}</option>
              <option value="preparing">{t('orderS.preparing')}</option>
              <option value="on way">{t('orderS.on way')}</option>
              <option value="delivered">{t('orderS.delivered')}</option>
              <option value="cancelled">{t('orderS.cancelled')}</option>
            </select>
          </div>
          {/* <span
        onClick={deleteOrders}
        className="bg-green-200 text-green-800 text-md font-semibold mr-2 px-3 py-[2px] rounded cursor-pointer"
      >Delete Orders</span> */}
          <div className="pt-4">
            <div className="relative overflow-x-auto rounded-md">
              <table
                className={`w-full text-sm ${
                  isRTL ? 'text-right' : 'text-left'
                } text-gray-700`}
              >
                <thead className="text-sm text-gray-700 uppercase bg-gray-200">
                  <tr>
                    <th scope="col" className="py-3 px-4">
                      {t('dashboardS.no')}
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-sm cursor-pointer"
                      onClick={() => handleSort('_id')}
                    >
                      {t('orderS.order_id')} {getSortIcon('_id')}
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 cursor-pointer"
                      onClick={() => handleSort('price')}
                    >
                      {t('products.price')} {getSortIcon('price')}
                    </th>
                    <th scope="col" className="px-6 py-3">
                      {t('dashboardS.payment_status')}
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 cursor-pointer"
                      onClick={() => handleSort('delivery_status')}
                    >
                      {t('orderS.order_status')}{' '}
                      {getSortIcon('delivery_status')}
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 cursor-pointer"
                      onClick={() => handleSort('createdAt')}
                    >
                      {t('orderS.order_date')} {getSortIcon('createdAt')}
                    </th>
                    <th scope="col" className="px-6 py-3">
                      {t('dashboardS.action')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData?.map((o, i) => (
                    <tr key={o._id} className="bg-white border-b">
                      <td className="py-2 px-4  whitespace-nowrap">{i + 1}</td>
                      <td className="px-6 py-4 font-medium whitespace-nowrap">
                        #{o.orderNumber}
                      </td>
                      <td className="px-6 py-4 font-medium whitespace-nowrap">
                        {o.price} {t('products.currency')}
                      </td>
                      <td className="px-6 py-4 font-medium whitespace-nowrap">
                        <span
                          className={`${
                            o.payment_status !== 'paid'
                              ? 'bg-red-200'
                              : 'bg-green-200'
                          } text-gray-700 text-md font-semibold mr-2 px-3 py-[2px] rounded`}
                        >
                          {o.payment_status}
                        </span>
                      </td>
                      <td className="px-6 py-4 font-medium whitespace-nowrap">
                        {t(`orderS.${o.delivery_status}`)}
                      </td>
                      <td className="py-2 px-4 whitespace-nowrap">
                        {o.createdAt.slice(0, 10)}
                      </td>
                      <td className="px-6 py-4 font-medium whitespace-nowrap">
                        <Link to={`/dashboard/order/details/${o._id}`}>
                          <FaEye size={24} color="#3e73ce" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

          </div>
        </div>
      )}
    </div>
  )
}

export default Orders
